import {
  useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery,
  useGetQuestionReviewTaskByIdQuery,
} from '@exam-management/graphql';
import { Flex, PaperSection } from '@shared/components';
import { useMemo } from 'react';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';
import { sortTaskByCode } from '../../utils';
import { QuestionReviewResultList } from '../question-review-result-list';

export default function QuestionReviewTaskReviewerSummarySection() {
  const {
    question,
    mainTaskDetails,
    workflowRoles: { isOwner },
  } = useQuestionReviewTaskQuestionDetails();

  const { data: taskResult, loading: isGettingTaskResult } = useGetQuestionReviewTaskByIdQuery({
    variables: {
      input: {
        taskId: mainTaskDetails?.id ?? '',
      },
    },
    skip: !mainTaskDetails,
  });

  const isSubtask = taskResult?.wflGetTaskById?.task?.parentTask !== null;
  const taskDetails = isSubtask
    ? taskResult?.wflGetTaskById?.task?.parentTask
    : taskResult?.wflGetTaskById?.task;

  const { data: questionDetailsResult, loading: isGettingQuestionDetails } =
    useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery({
      variables: {
        id: question.id,
        taskId: taskDetails?.id ?? '',
      },
      skip: !taskDetails || !question.id,
    });

  const subtasks = useMemo(() => {
    const questionDetails = questionDetailsResult?.qctGetTaskQuestionById;

    if (!taskDetails?.subtasks?.length || !questionDetails) {
      return [];
    }

    const sortedSubtasks = [...taskDetails.subtasks].sort(sortTaskByCode);

    return sortedSubtasks.map((subtask) => {
      const assignee = subtask.assignee;

      return {
        id: subtask.id,
        assignee: `${assignee.firstname} ${assignee.lastname}`,
        assigneeId: assignee.id,
        dueDate: subtask.dueDate,
        code: subtask.code,
      };
    });
  }, [taskDetails, questionDetailsResult]);

  const isLoading = isGettingTaskResult || isGettingQuestionDetails;

  if (!isOwner) {
    return null;
  }

  return (
    <PaperSection title='Review Result'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        <QuestionReviewResultList
          loading={isLoading}
          subtasks={subtasks}
          taskId={taskDetails?.id ?? ''}
          questionId={question.id}
        />
      </Flex>
    </PaperSection>
  );
}
